import { render, staticRenderFns } from "./private.vue?vue&type=template&id=d830d8b0&"
import script from "./private.js?vue&type=script&lang=js&"
export * from "./private.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports